module.exports = __webpack_public_path__ + "img/1728542627169-WhatsApp Image 2024-10-10 at 14.31.18.jpeg.cd7dcd10.webp";